var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.locationState)?_c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.selectComponent)?_c(_vm.selectComponent.component,_vm._g(_vm._b({key:_vm.locationDetail.visibleItem,tag:"component"},'component',_vm.selectComponent.binding,false),_vm.selectComponent?.listeners || {})):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }